import './App.css';
import TaskCrudView from './task/views/TaskCrudView'; 

const App = () => { 
  return (
      <TaskCrudView/>
  );
}

export default App;
